import { useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomCard, Title } from "../../Utils/UI/Text";
import EquivalentCodesBoard from "./EquivalentCodesBoard";
import { getEquivalentCodes } from "../Application/EquivalentCodes.business";
import {
  getEquivalentCodesSelector,
  getEquivalentCodesCountSelector,
} from "../Infrastructure/EquivalentCodes.reducer";
import "./EquivalentCodes.css";
import ExportButtonElement from "../../Layout/DesignSystem/ExportButton/Button";
import NewEquivalentCodes from "./NewEquivalentCodes";

const EquivalentCodes = () => {
  const equivalentCodes = useSelector(getEquivalentCodesSelector);
  const totalCountEquivalentCodes = useSelector(
    getEquivalentCodesCountSelector
  );

  useEffect(() => {
    getEquivalentCodes();
  }, []);
  return (
    <>
      <Title
        children="Códigos equivalentes"
        childrenTwo={
          <NewEquivalentCodes getEquivalentCodes={getEquivalentCodes} />
        }
        childrenThree={
          <ExportButtonElement type={"equivalentCodes"} text={"Exportar"} />
        }
      />
      <CustomCard>
        <EquivalentCodesBoard
          equivalentCodes={equivalentCodes}
          getEquivalentCodes={getEquivalentCodes}
          totalCountEquivalentCodes={totalCountEquivalentCodes}
        />
      </CustomCard>
    </>
  );
};

export default EquivalentCodes;
